import Transform from './Base';

export default class TeamsTransform extends Transform {
  /**
   * Method used to transform fetched teams.
   *
   * @param team The fetched team.
   *
   * @returns {Object} The transformed team.
   */
  static fetch(team) {
    return {
      id: team._id,
      team_short_name: team.team_short_name || '',
      team_name: team.team_name,
      country: team.country,
      city: team.city,
      external_id: !!team.external_id ? team.external_id : '',
    };
  }
}
